var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-container"},[_c('img',{attrs:{"src":"https://s.cd5i.com/vote/activity/cdch.jpeg","alt":""},on:{"click":function($event){return _vm.$router.push('/activity')}}})])}
var staticRenderFns = []

export { render, staticRenderFns }